<template>
    <!-- 疵点列表 -->
    <div style="padding: 20px;">
        <d-query-input :options="options" @query="queryBySelect" @clear="clearQuery" width="500px"
            :pageInfo="pageInfo" />
        <el-table :data="defectList" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border
            stripe>

            <el-table-column v-for="(obj,key,index) in defectInfoTimes" :key="index" :prop="key" :label="obj.value"
                :align="obj.align" />
            <!--            <el-table-column label="生产单编号" width="90" align="center">
                <template slot-scope="data">
                    <el-link type="primary" @click="goToProductDetails(data.row.productOrderId)">{{data.row.productOrderNumber}}</el-link>
                </template>
            </el-table-column> -->
            <el-table-column label="工单编号" align="center">
                <template slot-scope="data">
                    <el-link type="primary" @click="$refs.workOrderDetails.show(data.row.workOrderId)">
                        {{data.row.workOrderNumber}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="productLableNumber" label="落布标签号" align="center" width="200px">
            </el-table-column>
            <el-table-column v-for="(obj,key,index) in defectInfoKeys" :key="index" :prop="key" :label="obj.value"
                :align="obj.align" />
        </el-table>
        <el-pagination style="text-align: center" background layout="prev, pager, next" @current-change="getDefectList"
            :page-size="pageInfo.size" :current-page="pageInfo.page" :page-count="totalPages">
        </el-pagination>
        <work-order-details ref="workOrderDetails" />
    </div>
</template>

<script>
    import {
        workOrderDetails,
        dQueryInput
    } from '@/components/projectComponents'
    export default {
        components: {
            workOrderDetails,
            dQueryInput
        },
        data() {
            return {
                defectList: [],
                pageInfo: {
                    page: 1,
                    size: 20
                },
                totalPages: 0,
                defectInfoKeys: {
                    machineName: {
                        value: '机台(车间)',
                        align: 'center',
                        width: '120'
                    },
                    aliasName: {
                        value: '疵点别名',
                        align: 'center',
                        width: '120'
                    },
                    confidence: {
                        value: '疵点分数',
                        align: 'center',
                        width: '130'
                    },
                    // classId: { value: '疵点编号', align: 'center', width: '100' },
                    doorNumber: {
                        value: '发生门幅号',
                        align: 'center',
                        width: '100'
                    },
                    batchNumber: {
                        value: '发生批次号',
                        align: 'center',
                        width: '100'
                    },
                    // height: { value: '疵点高', align: 'center', width: '70' },
                    // width: { value: '疵点宽', align: 'center', width: '70' },
                    // centerX: { value: '疵点坐标X', align: 'center', width: '80' },
                    // centerY: { value: '疵点坐标Y', align: 'center', width: '80' },
                    // indexOfCamera: { value: '发生相机号', align: 'center', width: '80' },
                    lengthInBatch: {
                        value: '匹号中的米数',
                        align: 'center',
                        width: '100'
                    },
                    lengthInOrder: {
                        value: '工单中的米数',
                        align: 'center',
                        width: '100'
                    },
                    // lengthInShift: { value: '班次中的米数', align: 'right', width: '100' },
                    // lengthInTotal: { value: '发生时总米数', align: 'right', width: '100' },
                },

                defectInfoTimes: {
                    sendTime: {
                        value: '发生时间',
                        align: 'center',
                        width: '180'
                    }
                },
                options: [{
                    label: '生产单编号',
                    value: 'productOrderNumber'
                }, {
                    label: '工单编号',
                    value: 'workOrderNumber'
                }]
            }
        },
        methods: {
            // 获取疵点分页列表
            getDefectList(page) {
                this.pageInfo.page = page
                this.$requestBase({
                    url: 'v1/factory/defect/point/page',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.defectList = this.formatDefectList(res.data.list)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化分页列表
            formatDefectList(res) {
                res.forEach(item => {
                    item.machineName = `${item.machineNumber}(${item.machineWorkShop})`
                    item.sendTime = this.utils.timestampToTime(item.sendTime)
                    item.confidence = (item.confidence).toFixed(2)
                    item.lengthInBatch = this.utils.toMeter(item.lengthInBatch)
                    item.lengthInOrder = this.utils.toMeter(item.lengthInOrder)
                    item.lengthInShift = this.utils.toMeter(item.lengthInShift)
                    item.lengthInTotal = this.utils.toMeter(item.lengthInTotal)
                })
                return res
            },
            // 条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo
                this.getDefectList(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.getDefectList(1)
            },
            // 去生产单详情
            goToProductDetails(productOrderId) {
                this.$router.push(`productOrderList/productOrderDetalis/${productOrderId}`)
            }
        },
        created() {
            this.getDefectList(1)
        }
    }
</script>

<style scoped lang="scss">
</style>
